import React, { Component } from 'react';
import AccessDeniedBehavior from '../../../services/enums/accessDeniedBehavior';
import Permissions from '../../../services/enums/permissions';
import authorize from '../../authorization/authorize';
import EditRoleContainer from './editRoleContainer';

const AuthorizedEditRolesContainer = authorize([Permissions.manageRoles], AccessDeniedBehavior.displayError)(EditRoleContainer);

export default class EditRoleMainContainer extends Component {
  
    render() {
        
        return (
            <AuthorizedEditRolesContainer
                {...this.props}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/roles/editRole/index.jsx